import React from 'react';

interface Props {}

const Logout = (props: Props) => {
  return <div>Logout Page</div>;
};

export default Logout;
